import { type ZodString, z } from "zod";
import { localized } from "../../locales";
import { isValidIban } from "../../strings/is-valid-iban";

/** A required IBAN: stored compact and in capitals, and it must carry the right check digits. */
export const ZodIban = z.preprocess(
	(val) => (typeof val === "string" ? val.replace(/\s+/g, "").toUpperCase() : val),
	z.string().refine(isValidIban, { message: localized("general.invalid_iban") }),
) as unknown as ZodString;
